module.exports = __webpack_public_path__ + "media/amp_version/fastweb-a-monster-company-55041118.svg";